import axios from '@dap/shared-utils/http.js';

export default {
    // 获取头条字典
    getToutiaoDict (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/dict', { params });
    },
    // 获取自建站列表
    getSiteList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/sites', { params });
    },
    // 新建转化
    addConvert (params = {}) {
        return axios.post('/dapper/api/toutiao_ad/convert/add', params);
    },
    // 获取定向详情
    getTargetDetail (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/targeting/detail', { params });
    },

    addToutiaoCampaign (params = {}) {
        return axios.post('/dapper/api/toutiao_ad/ad/add', params);
    },

    getToutiaoCampiagnInfo (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/campaign/edit', { params });
    },

    saveToutiaoGroup (params = {}) {
        return axios.post('/dapper/api/toutiao_ad/adgroup/save', params);
    },

    // 编辑广告组
    touTiaoAdGroupDetail (type, params) {
        const typeMap = new Map();
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.get(`/dapper/api/toutiao_ad/${typeMap.get(type)}/edit`, {
            params,
        });
    },

    updateTouTiaoAdGroup (params) {
        return axios.post('/dapper/api/toutiao_ad/adgroup/save', params);
    },

    // 头条广告查询头条创意列表
    getTouTiaoCreativeList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/creative/list', { params });
    },

    updateCreativeStatus (params = {}) {
        return axios.post('/dapper/api/toutiao_ad/creative/update_status', params);
    },

    saveTouTiaoAd (params) {
        return axios.post('/dapper/api/toutiao_ad/ad/save', params);
    },

    //获取推送日志详情
    getSynchronizationLogList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/sync/log', { params });
    },
    //手动同步
    pushSynchronization (params = {}) {
        return axios.post('/dapper/api/toutiao_ad/sync/push', params);
    },
    //推送进度
    getScheduleList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/sync/process', { params });
    },
    // 定向包接口 （头条）
    getToutiaoAudiences (params = {}) {
        return axios.get('/dapper/api/aud/tt_ad/audiences', { params });
    },

    checkToutiaoName (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('group', 'adgroup');
        typeMap.set('ad', 'ad');
        return axios.get(`/dapper/api/toutiao_ad/${typeMap.get(type)}/checkname`, { params });
    },
};
